// extracted by mini-css-extract-plugin
module.exports = {"productFormWrapper":"ProductForm_productFormWrapper__wWPe_"};